<template>
  <v-dialog v-model="value" :width="width" persistent max-width="90vw">
    <v-card class="dialog-container">
      <v-toolbar class="elevation-1">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div :style="{ padding: pa }" style="max-height: 80vh;overflow-y: auto">
        <slot />
      </div>
      <transition name="slide-y-reverse-transition" appear>
        <div class="error pa-3" v-if="error">{{ error }}</div>
      </transition>

      <v-card-actions>
        <v-btn color="secondary" text @click="clear" v-if="clearBtn"
          >Clear</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="submit"
          v-if="submitBtn"
          :disabled="submitDisabled"
          >{{ submitTxt }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "Hive Popup"
    },
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: "600px"
    },
    submitBtn: {
      type: Boolean,
      default: true
    },
    submitDisabled: {
      type: Boolean,
      default: false
    },
    clearBtn: {
      type: Boolean,
      default: false
    },
    submitTxt: {
      type: String,
      default: "Submit"
    },
    pa: {
      type: String,
      default: "30px"
    },
    error: {
      type: String
    }
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    open() {
      this.$emit("input", true);
    },
    submit() {
      this.$emit("submit");
    },
    clear() {
      this.$emit("clear");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
::v-deep .v-card__actions {
  background-color: $light5;
  border-top: 1px solid $light6;
}
::v-deep .v-toolbar {
  background-color: $light5 !important;
}
.dialog-container {
  background-color: $light1;
}
</style>
